import React from 'react';
import Markdown from '../../../../sharedComponents/Markdown';
import { useUserContext } from '../../context';
import './index.scss';

function ProfileBio() {
  const { userData } = useUserContext();

  return (
    <div className="profile-bio">
      {userData.bio && (
        <Markdown>
          {userData.bio}
        </Markdown>
      )}
    </div>
  );
}

export default ProfileBio;
